/**
 * 联机对战后端地址配置。
 *
 * 前端静态站部署在 Deno Deploy，联机后端（Worker + Durable Object）部署在
 * Cloudflare，两者不同源，因此后端地址需要显式配置。本模块只使用浏览器
 * 标准 API（localStorage），不依赖 import.meta.env 等 Vite 专有特性，
 * 保证 src/ 同时能被 vite 与离线 tsc 两种构建使用。
 */

/**
 * 线上 PvP 后端（Cloudflare Worker）默认地址。
 * 部署：`npx wrangler deploy --config worker/wrangler.jsonc`（详见 worker/wrangler.jsonc）。
 */
export const DEFAULT_PVP_API_BASE = 'https://toon-tank-arena-pvp.sz1988.workers.dev';

/**
 * localStorage 覆盖键：本地联调时执行
 * `localStorage.setItem('PVP_API_BASE', 'http://127.0.0.1:8787')`
 * 即可把客户端指向 wrangler dev 起到的本地 Worker。
 */
export const PVP_API_BASE_STORAGE_KEY = 'PVP_API_BASE';

/**
 * 解析当前生效的 PvP 后端 HTTP 基地址。
 * 优先取 localStorage 覆盖值，取不到（或隐私模式访问抛异常）时回落默认地址。
 * 返回值已去掉末尾斜杠，调用方直接拼接路径即可。
 */
export function resolvePvpApiBase(): string {
  try {
    const override = window.localStorage.getItem(PVP_API_BASE_STORAGE_KEY);
    if (override !== null && override.trim() !== '') {
      return override.trim().replace(/\/+$/, '');
    }
  } catch {
    // 隐私模式 / 禁用存储时 localStorage 可能抛 SecurityError，静默回落默认地址
  }
  return DEFAULT_PVP_API_BASE;
}

/** 把 http(s) 基地址换算成对应的 ws(s) 基地址。 */
export function toWsBase(httpBase: string): string {
  if (httpBase.startsWith('https:')) return `wss:${httpBase.slice('https:'.length)}`;
  if (httpBase.startsWith('http:')) return `ws:${httpBase.slice('http:'.length)}`;
  // 已是 ws/wss 或其他形态时原样返回，由调用方保证传入合法
  return httpBase;
}
